/**
* 系统管理 角色管理
*/
<template>
	<div style="background: linear-gradient(180deg, #00bebd 0, #88fffe 50%, #fff 100%);padding: 20px;">
		<!-- 搜索筛选 -->
		<el-form :inline="true" class="user-search">
			<el-form-item label="">
				<el-input size="small" v-model="roleNo" placeholder="输入企业名"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
			</el-form-item>
			<div class="change-data" @click="getdata(1)">换一批</div>
		</el-form>
		<!--列表-->
		<div class="company-list">
			<ul>
				<li v-for="(item,index) in comlist" @click="handleEdit(index)">
					<a target="_blank" ka="brand_list_company_0" class="company-info">
						<img :src="item[2]">
						<div class="conpany-text">
							<h4>{{item[1]}}</h4>
							<span>{{item[3]}}</span>
						</div>
					</a>
				</li>
			</ul>
		</div>
		<el-dialog :title="title" width="1000px" :visible.sync="editFormVisible" @click="closeDialog()"
			v-if="nowindex!=-1">
			<div class="company-banner">
				<img :src="showcom[nowindex][2]" class="fl">
				<h1>
					{{showcom[nowindex][1]}}
				</h1>
			</div>
			<div class="company-info-box">
				<div class="job-sec">
					<h3>公司简介</h3>
					<div class="fold-text">{{showcom[nowindex][6]}}</div>
				</div>
				<div class="job-sec company-business">
					<h3>工商信息</h3>
					<div class="business-detail">
						<ul>
							<li class="business-detail-name"><span class="t">企业状态：</span>{{rz[showcom[nowindex][7]]}}
							</li>
							<li class="business-detail-user"><span class="t">法定代表人：</span>{{showcom[nowindex][4]}}</li>
							<li class="business-detail-type"><span class="t">企业类型：</span>{{showcom[nowindex][3]}}</li>
							<li class="business-detail-id"><span class="t">统一社会信用代码：</span>{{showcom[nowindex][5]}}</li>
						</ul>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import {
		RecSomeCompanies,
		LookTheCompanies,
		SearchTheCompanies,
		ApiRootUrl,
		PictureServer
	} from '../../api/userMG'
	import Pagination from '../../components/Pagination'
	export default {
		data() {
			return {
				loading: false, //是显示加载
				roleNo: '',
				isSearch: false,
				comlist: [],
				showcom: [],
				nowindex: -1,
				title: "查看企业",
				editFormVisible: false,
				rz: ['未认证', '已认证']
			}
		},
		created() {
			this.getdata(0)
		},
		methods: {
			getdata(type) {
				this.loading = true
				RecSomeCompanies(type).then(res => {
					this.comlist = res
					this.loading = false
					this.showcom = []
					this.nowindex = -1
				})
			},
			// 搜索事件
			search() {
				this.roleNo=this.roleNo.replace(/\s/g, "")
				this.roleNo=this.roleNo.replace("公司", "")
				this.roleNo=this.roleNo.replace("有限", "")
				this.roleNo=this.roleNo.replace("科技", "")
				this.loading = true
				if(this.roleNo.length>1){
					SearchTheCompanies({i:'%'+this.roleNo+'%'}).then(res => {
						this.comlist = res
						this.loading = false
						this.showcom = []
						this.nowindex = -1
					})
				}
			},
			handleEdit: function(index) {
				this.editFormVisible = false
				if (this.showcom[index]) {
					this.nowindex = index
					this.editFormVisible = true
				} else {
					LookTheCompanies(this.comlist[index][0]).then(re => {
						if (re) {
							this.showcom[index] = this.comlist[index].concat(re)
							this.nowindex = index
							this.editFormVisible = true
						}
					})
				}
			},
			// 关闭编辑、增加弹出框
			closeDialog() {
				this.editFormVisible = false
			}
		}
	}
</script>

<style scoped>
	.user-search {
		margin-top: 20px;
		position: relative;
	}

	.userRole {
		width: 100%;
	}

	.cell {
		font-size: 20px;
	}

	.change-data {
		position: absolute;
		top: 10px;
		right: 80px;
		color: #f2f5fa;
	}

	.company-list ul {
		height: auto;
		overflow: hidden;
	}

	.company-list li {
		border-radius: 12px;
		background: #fff;
		margin: 0 26px 31px 0;
		display: list-item;
		width: 354px;
		float: left;
		list-style: none;
		border-radius: 12px;
		height: 120px;
	}

	.company-info {
		border-bottom: none;
		height: 77px;
		margin: 0 20px;
		padding-top: 20px;
		color: #414a60;
		display: block;
	}

	.company-info img {
		width: 74px;
		height: 74px;
		float: left;
		border-radius: 10px;
		border: solid 1px #f2f5fa;
	}

	.conpany-text {
		text-align: left;
		margin-left: 89px;
		overflow: hidden;
		text-overflow: ellipsis;

	}

	.conpany-text h4 {
		margin: 9px 0;
		color: #222;
		height: 25px;
		line-height: 25px;
		font-size: 16px;
		font-weight: 400;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.conpany-text span {
		display: inline-block;
		color: #666;
		padding: 0 8px;
		background: #f8f8f8;
		font-size: 13px;
		border-radius: 4px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		line-height: 22px;
	}

	.company-banner {
		background-image: linear-gradient(90deg, #3b526a 0, #345a6d 100%);
		padding: 20px 0;
		line-height: 0;
		display: flex;
		border-radius: 12px;
		position: relative;
	}

	.company-banner img {
		width: 80px;
		height: 80px;
		border-radius: 12px;
		margin-left: 30px;
	}

	.company-banner h1 {
		font-size: 28px;
		font-weight: 600;
		color: #fff;
		line-height: 40px;
		margin-left: 30px;
	}

	.company-info-box {
		background: #fff;
		border-radius: 12px;
		padding: 10px 30px;
	}

	.company-info-box .job-sec h3 {
		font-size: 18px;
		font-weight: 600;
		color: #222;
		line-height: 25px;
		margin-bottom: 12px;
		padding: 0;
	}

	.company-info-box .fold-text {
		font-size: 15px;
		font-weight: 400;
		color: #333;
		line-height: 28px;
		max-height: 113px;
		overflow: hidden;
	}

	.company-business .business-detail {
		position: relative;
		border-radius: 12px;
		border: none;
		background: #f8f8f8;
		padding: 20px;
		height: auto;
	}

	.company-business .business-detail {
		position: relative;
		border-radius: 12px;
		border: none;
		background: #f8f8f8;
		padding: 20px;
		height: auto;
		display: grid;
	}

	.company-business .business-detail li {
		font-size: 15px;
		color: #333;
		line-height: 21px;
		padding: 0 5px 0 0;
		margin-bottom: 30px;
		-webkit-box-sizing: border-box;
		-moz-box-sizing: border-box;
		-ms-box-sizing: border-box;
		-o-box-sizing: border-box;
		box-sizing: border-box;
		width: 50%;
		float: left;
	}

	.company-business .business-detail li span {
		display: block;
		font-size: 14px;
		color: #999;
		line-height: 20px;
		margin-bottom: 8px;
	}
</style>


// WEBPACK FOOTER //
// src/views/school/enterpriseInquiry.vue